(function () {
  'use strict';

  if (window.CONSOLE_NOISE_FILTER_DISABLED) { return; }
  if (window.__consoleNoiseFilterInstalled) { return; }
  if (!window.console || typeof window.console.log !== 'function') { return; }
  window.__consoleNoiseFilterInstalled = true;

  // Each pattern must be specific enough that it cannot match a real message.
  var PATTERNS = [
    /^\[HotReload\]/,                              // Shopify CLI theme dev
    /SA Request a Quote/,                          // Samita RFQ banner
    /Request quotes or ask-for-price/,             // Samita RFQ advert
    /apps\.shopify\.com\/request-for-quote/,       // Samita RFQ advert link
    /GLO Color Swatch/,                            // Globo swatches banner
    /Trusted by 60,000\+ global merchants/,        // Globo swatches advert
    /apps\.shopify\.com\/globo-color-swatches/,    // Globo swatches advert link
    /^k-web-pixel-version/,                        // web pixel version stamp
    /^NTpopupInline$/                              // Kalles theme.min.js
  ];

  var MAX_KEPT = 200;
  var kept     = [];
  var dropped  = 0;

  var real = {
    log:            window.console.log.bind(window.console),
    info:           (window.console.info  || window.console.log).bind(window.console),
    debug:          (window.console.debug || window.console.log).bind(window.console),
    group:          (window.console.group || window.console.log).bind(window.console),
    groupCollapsed: (window.console.groupCollapsed || window.console.group || window.console.log).bind(window.console),
    groupEnd:       (window.console.groupEnd || function () {}).bind(window.console)
  };

  // Apps print their branding with console.group("%c" + title, styles), not
  // console.log -- Samita's banner is exactly that. Suppressing the header
  // alone would leave its groupEnd to close somebody else's group, so count
  // the ones we swallow and eat the matching groupEnd.
  var openSuppressedGroups = 0;

  function isNoise(args) {
    var parts = [];
    for (var i = 0; i < args.length; i++) {
      if (typeof args[i] === 'string') { parts.push(args[i]); }
    }
    // Trimmed: joining with a separator used to leave a trailing space, which
    // silently broke every $-anchored pattern (e.g. /^NTpopupInline$/).
    var text = parts.join(' ').trim();
    if (!text) { return false; }
    for (var p = 0; p < PATTERNS.length; p++) {
      if (PATTERNS[p].test(text)) { return true; }
    }
    return false;
  }

  function filtered(method) {
    return function () {
      var args = Array.prototype.slice.call(arguments);
      if (!isNoise(args)) { return real[method].apply(null, args); }

      dropped++;
      if (kept.length < MAX_KEPT) { kept.push({ method: method, args: args }); }
      if (window.CONSOLE_NOISE_FILTER_DEBUG) {
        real.log('[console-noise-filter] dropped #' + dropped, args[0]);
      }
    };
  }

  function filteredGroup(method) {
    return function () {
      var args = Array.prototype.slice.call(arguments);
      if (!isNoise(args)) { return real[method].apply(null, args); }

      openSuppressedGroups++;
      dropped++;
      if (kept.length < MAX_KEPT) { kept.push({ method: method, args: args }); }
      if (window.CONSOLE_NOISE_FILTER_DEBUG) {
        real.log('[console-noise-filter] dropped group #' + dropped, args[0]);
      }
    };
  }

  window.console.log            = filtered('log');
  window.console.info           = filtered('info');
  window.console.debug          = filtered('debug');
  window.console.group          = filteredGroup('group');
  window.console.groupCollapsed = filteredGroup('groupCollapsed');

  // Only ever cancels a groupEnd belonging to a header we swallowed, so real
  // grouping from other scripts stays balanced.
  window.console.groupEnd = function () {
    if (openSuppressedGroups > 0) {
      openSuppressedGroups--;
      return;
    }
    return real.groupEnd();
  };

  // Escape hatch: see or replay whatever was hidden.
  window.__consoleNoise = function (replay) {
    if (replay) {
      kept.forEach(function (entry) { real[entry.method].apply(null, entry.args); });
    }
    return { dropped: dropped, kept: kept.length, patterns: PATTERNS.length };
  };
})();